import { useField } from 'formik'
import PropTypes from 'prop-types'

export const MyTextInput = ({ isValid, label, ...props }) => {
  const [field] = useField(props)
  const textError = props.textError
  const valid = isValid === undefined || isValid === null ? true : isValid

  return (
    <div className="flex w-full flex-col justify-start">
      <div className={`${props.inputclass} relative`}>
        <label
          className="block text-sm font-medium text-gray-700"
          htmlFor={props.id || props.name}
        >
          {label}
        </label>
        <input
          className={
            `${
              valid
                ? 'border-gray-300 focus:border-gray-500 focus:ring-gray-500'
                : 'border-red-500 focus:border-red-500 focus:ring-red-500'
            }` +
            ' mt-1 block w-full appearance-none rounded-md shadow-sm sm:text-sm'
          }
          {...field}
          {...props}
        />
      </div>
      {!isValid ? <p className="text-[12px] text-red-600">{textError}</p> : ''}
    </div>
  )
}
export default MyTextInput

MyTextInput.propTypes = {
  isValid: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  textError: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  inputclass: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
}
